module.exports = __webpack_public_path__ + "img/f3-1.132511cc.png";